import UAParser from 'ua-parser-js';

const parser = new UAParser();

export default parser.getResult().device.type === 'tablet';



// WEBPACK FOOTER //
// ./src/utils/isTablet.js